import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    showNavbar: true,
    handleIsConnected: 0,
    relogin:false,
    showNotice:true,
    changeLang:0,
    totalData: {
      total_out_usdt: '0',
      total_out_eqx: '0',
      sum_tusd: '0'
    },
    wallet: {
      isConnected: false,
      address: '',
      initialized: false,
      listenerAttached: false
    },
    userInfo: null,
  },
  getters: {
    isWalletConnected: state => state.wallet.isConnected,
    walletAddress: state => state.wallet.address,
    userInfo: state => state.userInfo,
    shortWalletAddress: state => {
      const addr = state.wallet.address
      if (!addr) return ''
      return `${addr.slice(0, 6)}...${addr.slice(-4)}`
    }
  },
  mutations: {
    SET_WALLET(state, payload) {
      state.wallet.isConnected = !!payload.isConnected
      state.wallet.address = payload.address || ''
    },
    CLEAR_WALLET(state) {
      state.wallet.isConnected = false
      state.wallet.address = ''
    },
    SET_WALLET_INITIALIZED(state, payload) {
      state.wallet.initialized = !!payload
    },
    SET_WALLET_LISTENER_ATTACHED(state, payload) {
      state.wallet.listenerAttached = !!payload
    },
    setUserInfo(state, payload) {
      state.userInfo = payload || null
    }
  },
  actions: {
    async initWallet({ state, commit }) {
      if (state.wallet.initialized) return state.wallet.address
      commit('SET_WALLET_INITIALIZED', true)

      const eth = window.ethereum
      if (!eth || !eth.request) {
        commit('CLEAR_WALLET')
        return ''
      }

      try {
        const accounts = await eth.request({ method: 'eth_accounts' })
        const address = accounts && accounts[0] ? accounts[0] : ''
        commit('SET_WALLET', { isConnected: !!address, address })
      } catch (e) {
        commit('CLEAR_WALLET')
      }

      if (!state.wallet.listenerAttached && typeof eth.on === 'function') {
        commit('SET_WALLET_LISTENER_ATTACHED', true)

        eth.on('accountsChanged', accounts => {
          const address = accounts && accounts[0] ? accounts[0] : ''
          const prev = state.wallet.address
          commit('SET_WALLET', { isConnected: !!address, address })
          if (prev && address && prev.toLowerCase() === address.toLowerCase()) return
          if (prev && prev !== address) {
            localStorage.removeItem('BearerToken')
            commit('setUserInfo', null)
          }
        })
      }

      return state.wallet.address
    },
    async connectWallet({ commit }) {
      try {
        const eth = window.ethereum
        if (!eth || !eth.request) {
          throw new Error('No Ethereum provider')
        }
        const accounts = await eth.request({ method: 'eth_requestAccounts' })
        const address = accounts && accounts[0] ? accounts[0] : ''
        commit('SET_WALLET', { isConnected: !!address, address })
        return address
      } catch (e) {
        commit('CLEAR_WALLET')
        throw e
      }
    }
  },
  modules: {
  }
})
